import joi from 'joi';

import type { EdgeLabelsOptions } from '../edges';
import type {
  GraphEdgeSettingsStyle,
  GroupEdgeSettings,
  GroupEdgeSettingsId,
  PathLookupEdgeSettings,
  PathLookupEdgeSettingsId,
  TopologyEdgeSettings,
  TopologyEdgeSettingsId,
} from './EdgeSettings';
import {
  type PathLookupGraphEdgeSettings,
  type PathLookupGraphPreset,
  type PathLookupGraphSettings,
  pathLookupGraphSettingsSchema,
} from './PathLookupGraphPreset';
import {
  type TopologyGraphEdgeSettings,
  type TopologyGraphPreset,
  type TopologyGraphSettings,
  topologyGraphSettingsSchema,
} from './TopologyGraphPreset';

export const defaultEdgeThicknessThresholds: GraphEdgeSettingsStyle['thicknessThresholds'] =
  [2, 4, 8];

export const defaultEdgeLabelsOptions: EdgeLabelsOptions = {
  wrapCenterLabel: false,
  wrapLinecapLabel: false,
};

export type GraphSettings = TopologyGraphSettings | PathLookupGraphSettings;

export function isPathLookupGraphPreset(
  preset: TopologyGraphPreset | PathLookupGraphPreset,
): preset is PathLookupGraphPreset {
  return Object.hasOwnProperty.call(preset, 'pathLookup');
}

export function isTopologyGraphPreset(
  preset: TopologyGraphPreset | PathLookupGraphPreset,
): preset is TopologyGraphPreset {
  return Object.hasOwnProperty.call(preset, 'hiddenDeviceTypes');
}

export function isPathLookupGraphSettings(
  preset: TopologyGraphSettings | PathLookupGraphSettings,
): preset is PathLookupGraphSettings {
  return Object.hasOwnProperty.call(preset, 'pathLookup');
}

export function isTopologyGraphSettings(
  preset: TopologyGraphSettings | PathLookupGraphSettings,
): preset is TopologyGraphSettings {
  return Object.hasOwnProperty.call(preset, 'hiddenDeviceTypes');
}

export type GraphEdgeSettingsId =
  | TopologyEdgeSettingsId
  | GroupEdgeSettingsId
  | PathLookupEdgeSettingsId;

export type GraphEdgeSettings =
  | TopologyGraphEdgeSettings
  | PathLookupGraphEdgeSettings;

export type GraphEdgesSettings = GraphEdgeSettings[];

export const graphSettingsSchema = joi.alternatives([
  topologyGraphSettingsSchema,
  pathLookupGraphSettingsSchema,
]);

export function isGroupEdgeSettings(
  settings: GraphEdgeSettings,
): settings is GroupEdgeSettings {
  return settings.type === 'group';
}

export function isTopologyEdgeSettings(
  settings: GraphEdgeSettings,
): settings is TopologyEdgeSettings {
  return settings.type === 'protocol';
}

export function isPathLookupEdgeSettings(
  settings: GraphEdgeSettings,
): settings is PathLookupEdgeSettings {
  return settings.type === 'pathLookupEdge';
}
